module.exports = __webpack_public_path__ + "static/media/empty_invoices.0e2e6bc0.png";